import { zhCN } from "./zh-CN";

export const translations = {
  "zh-CN": zhCN,
  "en": {} // 英文使用原始文本
};

export function getTranslation(key: string, language: string = "en"): string {
  if (language === "zh-CN" && translations["zh-CN"][key]) {
    return translations["zh-CN"][key];
  }
  return key; // 默认返回原始英文文本
}

export function getCurrentLanguage(): string {
  const stored = localStorage.getItem("moltbot-language");
  if (stored) return stored;
  
  const browserLang = navigator.language;
  if (browserLang.startsWith("zh")) {
    return "zh-CN";
  }
  return "en";
}

export function setLanguage(language: string): void {
  localStorage.setItem("moltbot-language", language);
  window.location.reload();
}